import { Control, UseFormSetValue, useWatch } from 'react-hook-form';
import Assets from './Assets';
import { Values } from './types';
import useVaultAssets from '@/application/read/assets/useVaultAssets';
import { TokenId, getTotalTokenIds } from 'nftx.js';
import useVault from '@/application/read/vaults/useVault';
import { getQueryStatus } from '@/infrastructure/utils/getLoadingState';

const AssetsContainer = ({
  control,
  vaultId,
  setValue,
  maxItems,
}: {
  control: Control<Values>;
  vaultId: string;
  setValue: UseFormSetValue<Values>;
  maxItems: number;
}) => {
  const { data: vault } = useVault({ vaultId });
  const { status, fetchStatus, data: assets } = useVaultAssets({ vaultId });
  const { tokenIds = [] } = useWatch({ control });

  const handleToggleTokenId = (tokenId: TokenId) => {
    const newTokenIds = [...tokenIds];
    const item = newTokenIds.find(([x]) => x === tokenId);

    if (item) {
      newTokenIds.splice(newTokenIds.indexOf(item), 1);
    } else {
      newTokenIds.push([tokenId, 1]);
    }

    setValue('tokenIds', newTokenIds);
  };

  const handleQuantityChange = (tokenId: TokenId, value: number) => {
    const asset = assets?.find((x) => x.tokenId === tokenId);
    if (!asset) return;

    const newTokenIds = [...tokenIds];
    const item = newTokenIds.find(([x]) => x === tokenId);
    const i = item ? newTokenIds.indexOf(item) : -1;

    const totalOtherItems = getTotalTokenIds(newTokenIds) - (item?.[1] ?? 0);
    const maxForThisItem = Math.max(0, maxItems - totalOtherItems);

    value = Math.max(
      0,
      Math.min(value, Number(asset.quantity), maxForThisItem)
    );

    if (item && value > 0) {
      newTokenIds[i] = [tokenId, value];
    } else if (item && value === 0) {
      newTokenIds.splice(i, 1);
    } else if (!item && value > 0) {
      newTokenIds.push([tokenId, value]);
    }

    setValue('tokenIds', newTokenIds);
  };

  return (
    <Assets
      assetsStatus={getQueryStatus(status, fetchStatus)}
      assets={assets}
      tokenIds={tokenIds}
      maxItems={maxItems}
      onToggleTokenId={handleToggleTokenId}
      is1155={!!vault?.is1155}
      onQuantityChange={handleQuantityChange}
    />
  );
};

export default AssetsContainer;
